import { createSelector } from "reselect";

const state = (state) => state.streetInsights;

export const selectSelectedLocation = createSelector([state], (data) => data.selectedLocation);

export const selectLocationHistory = createSelector([state], (data) => data.locationHistory);
